import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Initialize OneSignal for push notifications (native app only)
if (window.cordova || window.Capacitor?.isNativePlatform?.()) {
  document.addEventListener('deviceready', () => {
    try {
      window.OneSignal = window.OneSignal || [];
      window.OneSignal.push(function() {
        window.OneSignal.init({
          appId: "fe8a6b83-640b-4a05-89ca-24ec235528b0",
          notifyButton: { enable: false },
          allowLocalhostAsSecureOrigin: true,
        });
        window.OneSignal.showSlidedownPrompt();
      });
    } catch (e) {
      console.log('OneSignal init error:', e);
    }
  }, false);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
